import React, { useState, useCallback, useEffect } from "react";
import { TextField, ChoiceList, Icon, Spinner } from "@shopify/polaris";
import { SearchMinor } from "@shopify/polaris-icons";
import styled from "styled-components";
import _ from "lodash";

const Container = styled.div`
  .choicelist-wrap {
    margin-top: 1rem;
  }
  .Polaris-ChoiceList__Choices {
    max-height: 280px;
    overflow-y: scroll;
    padding-left: 3px;
  }
`;

export const DepositsFilterByTargetPolaris = ({
  onChangeSearch,
  onChange,
  target,
  data,
  loading: loadingQuery,
  error,
}) => {
  const [inputValue, setInputValue] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [deselectedOptions, setDeselectedOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    setOptions(data);
    setDeselectedOptions(data);
    setSelectedOptions(target && target.value ? [target.value] : ["all"]);
    setInputValue(target ? target.search : null);

    if (target.search) {
      const filterRegex = new RegExp(target.search, "i");
      const resultOptions = data.filter((option) =>
        option.label.match(filterRegex)
      );
      setOptions(resultOptions);
    }
  }, [data, target]);

  useEffect(() => {
    setLoading(loadingQuery);
  }, [loadingQuery]);

  useEffect(() => {
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = useCallback(
    (value) => {
      setInputValue(value);
      if (onChangeSearch) {
        onChangeSearch({ search: value });
      }
      setLoading(true);
      if ("" === value) {
        const id = setTimeout(() => {
          setLoading(false);
          setOptions(deselectedOptions);
        }, 1000);
        setTimeoutId(id);
        return;
      }

      const filterRegex = new RegExp(value, "i");
      let resultOptions = deselectedOptions.filter((option) =>
        option.label.match(filterRegex)
      );

      const id = setTimeout(() => {
        setLoading(false);
        setOptions(resultOptions);
      }, 1000);
      setTimeoutId(id);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [deselectedOptions]
  );

  const handleSelection = useCallback(
    (selected) => {
      const selectedValue = selected.map((selectedItem) => {
        const matchedOption = options.find((option) => {
          return option.value === selectedItem;
        });
        return matchedOption && matchedOption.label;
      });
      setSelectedOptions(selected);
      if (onChange) {
        onChange({
          value: "all" !== _.head(selected) ? _.head(selected) : null,
          label: "All" !== _.head(selectedValue) ? _.head(selectedValue) : null,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [options]
  );

  return (
    <Container>
      <TextField
        value={inputValue}
        onChange={handleInputChange}
        prefix={<Icon source={SearchMinor} color="inkLighter" />}
        autoFocus={true}
        placeholder="Search ..."
      />
      <div className="mt-4">
        {error ? <div>Error: {error.toString()} </div> : null}
        {loading ? (
          <div className="flex justify-center">
            <Spinner
              accessibilityLabel="Spinner example"
              color="teal"
              size="small"
            />
          </div>
        ) : (
          <>
            {options.length ? (
              <div className="choicelist-wrap">
                <ChoiceList
                  title="suppliers"
                  titleHidden
                  choices={options}
                  selected={selectedOptions}
                  onChange={handleSelection}
                />
              </div>
            ) : (
              <span>No items found!</span>
            )}
          </>
        )}
      </div>
    </Container>
  );
};
